
// Define Change Model Constant
export const MODEL_CHANGE = "MODEL_CHANGE";
export type MODEL_CHANGE = typeof MODEL_CHANGE;

// Define Change Model Constant
export const DATASET_ID_CHANGE = "DATASET_ID_CHANGE";
export type DATASET_ID_CHANGE = typeof DATASET_ID_CHANGE;

// Define Change Model Constant
export const EXPLAIN_METHOD_ID_CHANGE = "EXPLAIN_METHOD_ID_CHANGE";
export type EXPLAIN_METHOD_ID_CHANGE = typeof EXPLAIN_METHOD_ID_CHANGE;


export const GRAPH_CHANGE = "GRAPH_CHANGE";
export type GRAPH_CHANGE = typeof GRAPH_CHANGE;

export const INIT_MODEL_LIST = "INIT_MODEL_LIST";
export type INIT_MODEL_LIST = typeof INIT_MODEL_LIST;

export const INIT_DATASET_LIST = "INIT_DATASET_LIST";
export type INIT_DATASET_LIST = typeof INIT_DATASET_LIST;

export const INIT_EXPLAIN_LIST = "INIT_EXPLAIN_LIST";
export type INIT_EXPLAIN_LIST = typeof INIT_EXPLAIN_LIST;

export const INIT_GRAPH_LIST = "INIT_GRAPH_LIST";
export type INIT_GRAPH_LIST = typeof INIT_GRAPH_LIST;

export const FILTERS_CHANGE = "FILTERS_CHANGE";
export type FILTERS_CHANGE = typeof FILTERS_CHANGE;

export const SELECTED_NODE_ID_LIST_CHANGE = "SELECTED_NODE_ID_LIST_CHANGE";
export type SELECTED_NODE_ID_LIST_CHANGE = typeof SELECTED_NODE_ID_LIST_CHANGE;

export const SELECTED_MESSAGE_PASSING_NODE_ID_LIST_CHANGE = "SELECTED_MESSAGE_PASSING_NODE_ID_LIST_CHANGE";
export type SELECTED_MESSAGE_PASSING_NODE_ID_LIST_CHANGE = typeof SELECTED_MESSAGE_PASSING_NODE_ID_LIST_CHANGE;

export const SHOW_SOURCE_CHANGE = "SHOW_SOURCE_CHANGE";
export type SHOW_SOURCE_CHANGE = typeof SHOW_SOURCE_CHANGE;

export const SPECIFIC_NODE_ID_LIST_CHANGE = "SPECIFIC_NODE_ID_LIST_CHANGE";
export type SPECIFIC_NODE_ID_LIST_CHANGE = typeof SPECIFIC_NODE_ID_LIST_CHANGE;


export const SELECT_INSPECT_NODE_CHANGE = "SELECT_INSPECT_NODE_CHANGE";
export type SELECT_INSPECT_NODE_CHANGE = typeof SELECT_INSPECT_NODE_CHANGE;

export const PREV_GRAPH_JSON_CHANGE = "PREV_GRAPH_JSON_CHANGE";
export type PREV_GRAPH_JSON_CHANGE = typeof PREV_GRAPH_JSON_CHANGE;


export const CLEAR_ID_INFO = "CLEAR_ID_INFO";
export type CLEAR_ID_INFO = typeof CLEAR_ID_INFO;

export const MATRIX_FILTERS_CHANGE = "MATRIX_FILTERS_CHANGE";
export type MATRIX_FILTERS_CHANGE = typeof MATRIX_FILTERS_CHANGE;

export const MATRIX_ROW_FILTERS_CHANGE = "MATRIX_ROW_FILTERS_CHANGE";
export type MATRIX_ROW_FILTERS_CHANGE = typeof MATRIX_ROW_FILTERS_CHANGE;

export const INSPECT_CATEGORY_LIST_CHANGE = "INSPECT_CATEGORY_LIST_CHANGE";
export type INSPECT_CATEGORY_LIST_CHANGE = typeof INSPECT_CATEGORY_LIST_CHANGE;

export const PSJSON_CHANGE = "PSJSON_CHANGE";
export type PSJSON_CHANGE = typeof PSJSON_CHANGE;

export const PSSELECTEDNODES_CHANGE = "PSSELECTEDNODES_CHANGE";
export type PSSELECTEDNODES_CHANGE = typeof PSSELECTEDNODES_CHANGE;


export const PSDIMENSIONS_CHANGE = "PSDIMENSIONS_CHANGE";
export type PSDIMENSIONS_CHANGE = typeof PSDIMENSIONS_CHANGE;

export const EXTENDED_MODE_CHANGE = "EXTENDED_MODE_CHANGE";
export type EXTENDED_MODE_CHANGE = typeof EXTENDED_MODE_CHANGE;

export const PROJECTIONVIEWSELECTEDNODES_CHANGE = "PROJECTIONVIEWSELECTEDNODES_CHANGE";
export type PROJECTIONVIEWSELECTEDNODES_CHANGE = typeof PROJECTIONVIEWSELECTEDNODES_CHANGE;


export const PROJECTIONVIEWTOTALNODENUM_CHANGE = "PROJECTIONVIEWTOTALNODENUM_CHANGE";
export type PROJECTIONVIEWTOTALNODENUM_CHANGE = typeof PROJECTIONVIEWTOTALNODENUM_CHANGE;

export const PSSETTINGMODAL_VISIBLE_CHANGE = "PSSETTINGMODAL_VISIBLE_CHANGE";
export type PSSETTINGMODAL_VISIBLE_CHANGE = typeof PSSETTINGMODAL_VISIBLE_CHANGE;

export const PROJECTIONVIEWSETTINGMODAL_VISIBLE_CHANGE = "PROJECTIONVIEWSETTINGMODAL_VISIBLE_CHANGE";
export type PROJECTIONVIEWSETTINGMODAL_VISIBLE_CHANGE = typeof PROJECTIONVIEWSETTINGMODAL_VISIBLE_CHANGE;

export const GRAPHVIEWSETTINGMODAL_VISIBLE_CHANGE = "GRAPHVIEWSETTINGMODAL_VISIBLE_CHANGE";
export type GRAPHVIEWSETTINGMODAL_VISIBLE_CHANGE = typeof GRAPHVIEWSETTINGMODAL_VISIBLE_CHANGE;

export const FEATUREMATRIXVIEWSETTINGMODAL_VISIBLE_CHANGE = "FEATUREMATRIXVIEWSETTINGMODAL_VISIBLE_CHANGE";
export type FEATUREMATRIXVIEWSETTINGMODAL_VISIBLE_CHANGE = typeof FEATUREMATRIXVIEWSETTINGMODAL_VISIBLE_CHANGE;


export const GRAPHVIEWSTATE_CHANGE = "GRAPHVIEWSTATE_CHANGE";
export type GRAPHVIEWSTATE_CHANGE = typeof GRAPHVIEWSTATE_CHANGE;


export const KVALUE_CHANGE = "KVALUE_CHANGE";
export type KVALUE_CHANGE = typeof KVALUE_CHANGE;

export const SELECTEDMODELS_CHANGE = "SELECTEDMODELS_CHANGE";
export type SELECTEDMODELS_CHANGE = typeof SELECTEDMODELS_CHANGE;

export const MODELSLIST_CHANGE = "MODELSLIST_CHANGE";
export type MODELSLIST_CHANGE = typeof MODELSLIST_CHANGE;

export const CHANGE_LOADING_DATASET = "CHANGE_LOADING_DATASET";
export type  CHANGE_LOADING_DATASET = typeof CHANGE_LOADING_DATASET;
/*// 定义增加 state 类型常量
export const INCREMENT = "INCREMENT";
export type INCREMENT = typeof INCREMENT;

// 定义减少 state 类型常量
export const DECREMENT = "DECREMENT";
export type DECREMENT = typeof DECREMENT;
*/